module.exports = __webpack_public_path__ + "img/icones_kypho-1.7e8b4f12.png";